/* Bowtie pack roller — deals real in-stock plants, lock/reroll, then one add-to-cart. */
(function () {
  var root = document.getElementById('bw-roll');
  if (!root) return;

  var FREE_SHIP = parseInt(root.getAttribute('data-free-ship'), 10) || 4900;
  var B3G4_BUY = parseInt(root.getAttribute('data-b3g4'), 10) || 3; // buy N, get 1 free

  var CATALOG = [];
  var SUB = null;
  try { CATALOG = JSON.parse(document.querySelector('[data-roll-data]').textContent) || []; } catch (e) {}
  var subEl = document.querySelector('[data-roll-sub]');
  if (subEl) { try { SUB = JSON.parse(subEl.textContent); } catch (e) {} }
  // state.sub: '0' none | '1' 1.5 gal | '2' 5 gal
  function curSub() {
    if (!SUB) return null;
    if (state.sub === '1') return SUB.s || null;
    if (state.sub === '2') return SUB.l || null;
    return null;
  }

  // ---- derive lineage tokens from the cross names, e.g. "(AOS x Forgetii) x Carla"
  var STOP = /^(self|open|x\d+|noid)$/i;
  function parentsOf(title) {
    var t = String(title).replace(/^Anthurium\s+/i, '');
    return t.split(/\s+x\s+/i)
      .map(function (s) { return s.replace(/[()\u2018\u2019'"]/g, '').trim(); })
      .filter(function (s) { return s.length > 2 && s.length < 26 && !STOP.test(s); });
  }
  CATALOG.forEach(function (p) {
    p.parents = parentsOf(p.t);
    p.tagList = (p.tags || '').split('||');
    p.size = (p.tagList.filter(function (x) { return /^size:/.test(x); })[0] || '').replace(/^size:/, '');
  });

  function money(c) { return '$' + (c / 100).toFixed(2); }

  // top lineage chips by frequency
  var freq = {};
  CATALOG.forEach(function (p) { p.parents.forEach(function (n) { freq[n] = (freq[n] || 0) + 1; }); });
  var topParents = Object.keys(freq).filter(function (n) { return freq[n] >= 3; })
    .sort(function (a, b) { return freq[b] - freq[a]; }).slice(0, 10);

  var lineageWrap = root.querySelector('[data-group="parent"]');
  if (topParents.length) {
    topParents.forEach(function (n) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bw-chip'; b.setAttribute('data-val', n); b.textContent = n;
      lineageWrap.appendChild(b);
    });
  } else {
    var row = root.querySelector('[data-lineage-row]'); if (row) row.hidden = true;
  }

  // ---- filter state
  var state = { size: '', price: '', parent: [], count: 4, sub: '1' };

  /* ---- behavior tracking (Nick, 2026-09-07): the roller left no fingerprint on the
     order, so roller sales were indistinguishable from normal ones. Every counter here
     is written onto the cart as attributes + hidden line-item properties at add time. */
  var BWT = {
    t0: Date.now(), rolls: 0, swaps: 0, undos: 0, locks: 0, views: 0, filters: 0,
    seen: [], seenIds: {}, ready: false, log: [], sid: ''
  };
  /* session id + who: so a test session is never mistaken for a customer (Nick, 2026-09-07).
     ?rollertest=nick (or =viktor) on any URL marks this browser for the rest of the tab. */
  try {
    var ss = window.sessionStorage;
    BWT.sid = ss.getItem('bwt_sid') || (Date.now().toString(36) + Math.random().toString(36).slice(2, 7));
    ss.setItem('bwt_sid', BWT.sid);
    var qt = (location.search.match(/[?&]rollertest=([^&]+)/) || [])[1];
    if (qt) ss.setItem('bwt_tester', decodeURIComponent(qt));
    BWT.tester = ss.getItem('bwt_tester') || '';
  } catch (e) { BWT.sid = Math.random().toString(36).slice(2, 9); BWT.tester = ''; }
  if (!BWT.tester && navigator.webdriver) BWT.tester = 'automation';
  function bwtWho() {
    /* logged-in shoppers: Shopify exposes the customer id on the storefront */
    var cid = '';
    try {
      cid = (window.__st && window.__st.cid) ||
        (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page &&
          ShopifyAnalytics.meta.page.customerId) || '';
    } catch (e) {}
    if (BWT.tester) return 'TEST:' + BWT.tester;
    return cid ? 'customer ' + cid : 'guest';
  }
  function bwtNow() { return new Date().toISOString().replace('T', ' ').slice(0, 19); }
  function bwtLog(action, detail) {
    var t = Math.round((Date.now() - BWT.t0) / 1000);
    BWT.log.push(t + 's ' + action + (detail ? ':' + detail : ''));
    if (BWT.log.length > 120) BWT.log.shift();
  }
  function bwtSee(list) {
    list.forEach(function (it) {
      if (!it || BWT.seenIds[it.id]) return;
      BWT.seenIds[it.id] = 1; BWT.seen.push(it.t);
    });
  }
  function bwtFilters() {
    var b = [];
    if (state.count !== 4) b.push('pack:' + state.count);
    if (state.price) b.push('budget:' + state.price);
    if (state.size) b.push('size:' + state.size);
    if (state.parent.length) b.push('lineage:' + state.parent.join('|'));
    return b.join(', ') || 'none';
  }
  function bwtClip(a, max) {
    var out = a.join(' | ');
    return out.length > max ? out.slice(0, max - 1) + '\u2026' : out;
  }

  root.querySelectorAll('.bw-roll__chips').forEach(function (grp) {
    var group = grp.getAttribute('data-group');
    grp.addEventListener('click', function (e) {
      var btn = e.target.closest('.bw-chip,.bw-subbtn'); if (!btn) return;
      var val = btn.getAttribute('data-val');
      if (group === 'parent') {
        btn.classList.toggle('is-on');
        state.parent = [].slice.call(grp.querySelectorAll('.bw-chip.is-on,.bw-subbtn.is-on')).map(function (b) { return b.getAttribute('data-val'); });
      } else {
        grp.querySelectorAll('.bw-chip,.bw-subbtn').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
        state[group] = (group === 'count') ? parseInt(val, 10) : val;
      }
      /* Nick, 2026-09-05: substrate is an add-on, not a filter — changing it must NOT
         reroll the seedlings. Only real filters redeal. */
      if (group === 'sub') { if (hand.length) render(); return; }
      BWT.filters++;
      bwtLog('filter', group + '=' + val);
      renderFsum();
      if (hand.length) deal(true); // live-update an existing hand, keeping locks
    });
  });

  function matches(p) {
    if (state.size && p.size !== state.size) return false;
    if (state.price) {
      var b = state.price.split('-'), lo = +b[0], hi = +b[1];
      if (p.p < lo || p.p > hi) return false;
    }
    if (state.parent.length) {
      var hit = p.parents.some(function (n) {
        return state.parent.some(function (s) { return n.toLowerCase().indexOf(s.toLowerCase()) !== -1; });
      });
      if (!hit) return false;
    }
    return true;
  }

  /* Nick, 2026-09-05 (r8): filters were only visible inside the gear panel, with no way to
     see or clear what was on. This renders the active ones as removable chips above the reels. */
  var fsumEl = root.querySelector('[data-roll-fsum]');
  var FLABEL = { price: 'Budget', count: 'Pack size' };

  function setChip(group, val) {
    var grp = root.querySelector('.bw-roll__chips[data-group="' + group + '"]');
    if (!grp) return;
    grp.querySelectorAll('.bw-chip').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-val') === String(val));
    });
  }

  function clearFilter(kind, val) {
    if (kind === 'price') { state.price = ''; setChip('price', ''); }
    else if (kind === 'count') { state.count = 4; setChip('count', '4'); }
    else if (kind === 'parent') {
      state.parent = state.parent.filter(function (p) { return p !== val; });
      var grp = root.querySelector('.bw-roll__chips[data-group="parent"]');
      if (grp) grp.querySelectorAll('.bw-chip').forEach(function (b) {
        if (b.getAttribute('data-val') === val) b.classList.remove('is-on');
      });
    } else if (kind === 'all') {
      state.price = ''; state.parent = []; state.count = 4;
      setChip('price', ''); setChip('count', '4');
      var pg = root.querySelector('.bw-roll__chips[data-group="parent"]');
      if (pg) pg.querySelectorAll('.bw-chip').forEach(function (b) { b.classList.remove('is-on'); });
    }
    renderFsum();
    deal(true);
  }

  function renderFsum() {
    if (!fsumEl) return;
    var bits = [];
    if (state.count !== 4) bits.push({ k: 'count', v: '', t: FLABEL.count + ': ' + state.count });
    if (state.price) {
      var on = root.querySelector('.bw-roll__chips[data-group="price"] .bw-chip.is-on');
      bits.push({ k: 'price', v: '', t: FLABEL.price + ': ' + (on ? on.textContent.trim() : state.price) });
    }
    state.parent.forEach(function (p) { bits.push({ k: 'parent', v: p, t: p }); });
    if (!bits.length) { fsumEl.hidden = true; fsumEl.innerHTML = ''; return; }
    fsumEl.hidden = false;
    fsumEl.innerHTML = '<span class="bw-fsum__lbl">Filtered to</span>' +
      bits.map(function (b) {
        return '<button type="button" class="bw-fsum__chip" data-fclear="' + b.k + '" data-fval="' +
          String(b.v).replace(/"/g, '&quot;') + '">' + b.t + ' <span aria-hidden="true">&times;</span></button>';
      }).join('') +
      '<button type="button" class="bw-fsum__all" data-fclear="all">Clear all</button>' +
      '<button type="button" class="bw-fsum__edit" data-fsum-edit>Change</button>';
  }

  if (fsumEl) {
    fsumEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-fsum-edit]')) {
        var rb = root.querySelector('[data-roll-refine]'); if (rb) rb.click();
        return;
      }
      var b = e.target.closest('[data-fclear]'); if (!b) return;
      clearFilter(b.getAttribute('data-fclear'), b.getAttribute('data-fval') || '');
    });
  }

  // ---- the hand
  var hand = []; // {item, locked}
  var gridEl  = root.querySelector('[data-roll-grid]');
  var footEl  = root.querySelector('[data-roll-foot]');
  var emptyEl = root.querySelector('[data-roll-empty]');
  var againEls = [].slice.call(root.querySelectorAll('[data-roll-again]'));
  var againEl = againEls[0];

  function pickPool(exclude) {
    var used = {}; (exclude || []).forEach(function (x) { used[x.id] = 1; });
    return CATALOG.filter(function (p) { return matches(p) && !used[p.id]; });
  }

  function deal(keepLocks) {
    animateNext = true;
    if (hand.length) pushHistory(-1, hand.slice());
    var locked = keepLocks ? hand.filter(function (h) { return h.locked; }) : [];
    var need = state.count - locked.length;
    if (need < 0) { locked = locked.slice(0, state.count); need = 0; }
    var pool = pickPool(locked.map(function (h) { return h.item; }));

    if (locked.length === 0 && pool.length === 0) {
      hand = []; render();
      emptyEl.hidden = false;
      emptyEl.textContent = 'Nothing in stock matches that combination right now — try loosening one filter.';
      return;
    }
    emptyEl.hidden = true;

    var picks = [];
    var bag = pool.slice();
    for (var i = 0; i < need && bag.length; i++) {
      var j = Math.floor(Math.random() * bag.length);
      picks.push(bag.splice(j, 1)[0]);
    }
    hand = locked.concat(picks.map(function (it) { return { item: it, locked: false }; }));
    if (BWT.ready) { BWT.rolls++; bwtLog(keepLocks ? 'roll-again' : 'new-hand'); }
    bwtSee(hand.map(function (h) { return h.item; }));
    if (hand.length && hand.length < state.count) {
      emptyEl.hidden = false;
      emptyEl.textContent = 'Only ' + hand.length + ' in stock match that right now — here they are.';
    }
    render();
  }

  function rerollOne(idx) {
    var others = hand.filter(function (_, i) { return i !== idx; }).map(function (h) { return h.item; });
    var pool = pickPool(others);
    if (!pool.length) return;
    pushHistory(idx, hand[idx] && hand[idx].item);
    hand[idx] = { item: pool[Math.floor(Math.random() * pool.length)], locked: false };
    BWT.swaps++; bwtLog('swap', hand[idx].item.t); bwtSee([hand[idx].item]);
    animateNext = true;
    render();
  }

  function totals() {
    var n = hand.length;
    var prices = hand.map(function (h) { return h.item.p; }).sort(function (a, b) { return a - b; });
    var gross = prices.reduce(function (a, b) { return a + b; }, 0);
    // B3G4: every (BUY+1) plants, the cheapest of that group is free
    var freeCount = Math.floor(n / (B3G4_BUY + 1));
    var freed = prices.slice(0, freeCount).reduce(function (a, b) { return a + b; }, 0);
    var cs = curSub();
    var subCost = cs ? cs.p : 0;
    return { n: n, gross: gross + subCost, net: gross - freed + subCost, freed: freed, freeCount: freeCount };
  }

  var animateNext = false;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var history = [];      // undo stack: {idx, prev}
  var undoEls = [].slice.call(root.querySelectorAll('[data-roll-undo]'));
  function showUndo(on) { undoEls.forEach(function (b) { b.hidden = !on; }); }

  function pushHistory(idx, prev) {
    if (!prev) return;
    history.push({ idx: idx, prev: prev });
    if (history.length > 12) history.shift();
    showUndo(true);
  }
  function undo() {
    var h = history.pop();
    if (!h) return;
    BWT.undos++; bwtLog('go-back');
    if (h.idx === -1) { hand = h.prev.slice(); }
    else if (hand[h.idx]) { hand[h.idx] = { item: h.prev, locked: false }; }
    showUndo(history.length > 0);
    render();
    var card = gridEl.children[h.idx === -1 ? 0 : h.idx];
    if (card) { card.classList.add('is-undone'); setTimeout(function(){ card.classList.remove('is-undone'); }, 700); }
  }
  undoEls.forEach(function (b) { b.addEventListener('click', undo); });

  // ---- slot reel: reels spin together, then LOCK IN one at a time, left to right
  function spinTile(card, finalSrc, holdMs, done) {
    var img = card.querySelector('.bw-rc__img');
    if (!img || REDUCED) { if (done) done(); return; }
    var reel = [];
    for (var i = 0; i < 18; i++) {
      var p = CATALOG[Math.floor(Math.random() * CATALOG.length)];
      if (p && p.img) reel.push(p.img);
    }
    if (!reel.length) { if (done) done(); return; }
    card.classList.add('is-spinning');
    var k = Math.floor(Math.random() * reel.length);
    var stopAt = Date.now() + holdMs, tick = 60;
    function step() {
      if (Date.now() >= stopAt) {
        img.src = finalSrc;
        card.classList.remove('is-spinning');
        card.classList.add('is-landed');
        setTimeout(function () { card.classList.remove('is-landed'); }, 600);
        if (done) done();
        return;
      }
      img.src = reel[k++ % reel.length];
      var left = stopAt - Date.now();
      tick = left < 450 ? Math.min(tick * 1.35, 190) : 60;   // steady spin, then decelerate
      setTimeout(step, tick);
    }
    step();
  }

  // spin the whole hand, locking each reel in sequence — that's the slot-machine beat
  function spinHand(cards, srcs, done) {
    if (REDUCED || !cards.length) { if (done) done(); return; }
    var landed = 0;
    cards.forEach(function (card, i) {
      spinTile(card, srcs[i], 900 + i * 620, function () {
        if (++landed >= cards.length && done) done();
      });
    });
  }

  // ---- the win moment: the machine kicks, light sweeps the reels, payout rains down
  function confetti(target) {
    if (REDUCED) return;
    var host = document.createElement('div');
    host.className = 'bw-confetti';
    (target || root).appendChild(host);

    var mach = root.querySelector('.bw-mach');
    if (mach) {
      mach.classList.add('is-payout');
      setTimeout(function () { mach.classList.remove('is-payout'); }, 900);
    }
    var sweep = document.createElement('span');
    sweep.className = 'bw-sweep';
    host.appendChild(sweep);

    var colors = ['#7fb646', '#5f9130', '#e9d16b', '#ffffff', '#b7e08a', '#f4a93c'];
    var shapes = ['leaf', 'strip', 'dot', 'coin'];
    for (var i = 0; i < 54; i++) {
      var b = document.createElement('i');
      b.className = 'bw-cf bw-cf--' + shapes[i % shapes.length];
      b.style.left = (Math.random() * 100) + '%';
      b.style.background = colors[i % colors.length];
      b.style.animationDelay = (Math.random() * 420) + 'ms';
      b.style.animationDuration = (900 + Math.random() * 900) + 'ms';
      b.style.setProperty('--dx', (Math.random() * 120 - 60) + 'px');
      b.style.setProperty('--spin', (Math.random() * 900 - 450) + 'deg');
      host.appendChild(b);
    }
    setTimeout(function () { host.remove(); }, 2600);
  }

  function render() {
    gridEl.innerHTML = '';
    againEls.forEach(function (b) { b.hidden = hand.length === 0; });
    /* Nick, 2026-09-05 (r8): with 8+ plants the top SPIN scrolls out of reach,
       so a second one appears under the reels only at that size. */
    var spinRow = root.querySelector('[data-roll-spinrow]');
    if (spinRow) spinRow.hidden = hand.length < 8;
    footEl.hidden = hand.length === 0;
    var startEl = root.querySelector('.bw-mach__start');
    if (startEl) startEl.hidden = hand.length > 0;
    if (!hand.length) return;

    var spinCards = [], spinSrcs = [];
    hand.forEach(function (h, i) {
      var c = document.createElement('div');
      c.className = 'bw-rc' + (h.locked ? ' is-locked' : '');
      c.innerHTML =
        '<div class="bw-rc__imgwrap">' +
          (h.item.img ? '<img class="bw-rc__img" src="' + h.item.img + '" alt="" loading="lazy">' : '') +
          '<button type="button" class="bw-rc__info" data-info="' + i + '" aria-label="Photos and details">i</button>' +
          '<div class="bw-rc__keep' + (h.locked ? ' is-on' : '') + '" data-lock="' + i + '" role="button" tabindex="0" ' +
            'aria-pressed="' + h.locked + '" aria-label="' + (h.locked ? 'Locked in \u2014 tap to release' : 'Lock this one in') + '">' +
            '<span class="bw-rc__lock">' + (h.locked ? '&#10084;' : '&#9825;') + '</span>' +
            '<span class="bw-rc__keeplbl">' + (h.locked ? 'Locked in' : 'Lock it in') + '</span>' +
          '</div>' +
          '<button type="button" class="bw-rc__swap" data-swap="' + i + '" aria-label="Swap this one">&#8635;</button>' +
          '<div class="bw-rc__cap" data-info="' + i + '">' +
            '<span class="bw-rc__t">' + h.item.t.replace(/^Anthurium\s+/i, '') + '</span>' +
            '<span class="bw-rc__p">' + money(h.item.p) + '</span>' +
          '</div>' +
        '</div>';
      gridEl.appendChild(c);
      if (animateNext && !h.locked) { spinCards.push(c); spinSrcs.push(h.item.img); }
    });
    if (animateNext && spinCards.length) {
      spinHand(spinCards, spinSrcs, function () {
        confetti(root.querySelector('.bw-mach__reels') || gridEl);
      });
    }
    animateNext = false;

    var t = totals();

    // Nick, 2026-09-02: once they pick 8, offer the next B3G4 tier instead of making
    // them find the 12 chip. The 12 chip is hidden until this activates it.
    /* Nick, 2026-09-05 (r6): the next-tier offer lives INSIDE the free-plant line,
       not as its own button — too many buttons otherwise. */
    var NEXT = { 2: 4, 4: 8, 6: 8, 8: 12 };
    var moreHtml = '';
    (function () {
      var nx = NEXT[state.count];
      if (!nx) return;
      var haveFree = Math.floor(state.count / (B3G4_BUY + 1));
      var willFree = Math.floor(nx / (B3G4_BUY + 1));
      var gain = willFree - haveFree;
      var ord = ['', '1st', '2nd', '3rd', '4th', '5th'][willFree] || (willFree + 'th');
      var label = gain <= 0 ? 'Make it ' + nx
        : (gain === 1 ? 'Make it ' + nx + ' \u2192 ' + ord + ' one free'
                      : 'Make it ' + nx + ' \u2192 ' + gain + ' more free');
      moreHtml = '<button type="button" class="bw-roll__more" data-roll-more data-next="' + nx + '">' +
        label + '</button>';
    })();
    var b3 = root.querySelector('[data-roll-b3g4]');
    var toNext = (B3G4_BUY + 1) - (t.n % (B3G4_BUY + 1));
    var group = B3G4_BUY + 1;
    // Nick, 2026-09-05 (r6): the dots were decorative. One dot per plant in the pack,
    // lit for every plant you've locked in; every 4th dot is the free slot.
    var lockedN = hand.filter(function (h) { return h.locked; }).length;
    var pips = '';
    for (var pi = 0; pi < hand.length; pi++) {
      var cls = 'bw-roll__pip';
      if ((pi + 1) % group === 0) cls += ' is-free';
      if (pi < lockedN) cls += ' is-full';
      pips += '<span class="' + cls + '"></span>';
    }
    pips = '<span class="bw-roll__pipset" aria-hidden="true">' + pips + '</span>';
    var lockNote = '<span class="bw-roll__piptext is-muted">' +
      (lockedN ? lockedN + ' of ' + hand.length + ' locked in' : 'Tap a heart to lock one in') + '</span>';
    b3.className = 'bw-roll__bar bw-roll__pips' + (t.freeCount > 0 ? ' is-win' : '');
    if (t.freeCount > 0) {
      b3.innerHTML = pips + '<span class="bw-roll__piptext">&#10003; ' + t.freeCount + ' plant' +
        (t.freeCount > 1 ? 's' : '') + ' free &mdash; you save ' + money(t.freed) + '</span>' +
        lockNote + moreHtml;
    } else {
      b3.innerHTML = pips + '<span class="bw-roll__piptext is-muted">Add ' + toNext +
        ' more and the cheapest one is <strong>free</strong></span>' + lockNote + moreHtml;
    }
    var ship = root.querySelector('[data-roll-ship]');
    if (t.net >= FREE_SHIP) {
      ship.className = 'bw-roll__bar is-win';
      ship.innerHTML = '<span class="bw-roll__ship-badge">&#10003; FREE SHIPPING</span>';
    } else {
      ship.className = 'bw-roll__bar';
      ship.innerHTML = money(FREE_SHIP - t.net) + ' from free shipping.';
    }
    root.querySelector('[data-roll-was]').textContent = t.net < t.gross ? money(t.gross) : '';
    root.querySelector('[data-roll-now]').textContent = money(t.net);
  }

  gridEl.addEventListener('click', function (e) {
    var lock = e.target.closest('[data-lock]');
    if (lock) { var i = +lock.getAttribute('data-lock'); hand[i].locked = !hand[i].locked; if (hand[i].locked) BWT.locks++;
      bwtLog(hand[i].locked ? 'lock' : 'unlock', hand[i].item.t); render(); return; }
    var swap = e.target.closest('[data-swap]');
    if (swap) { rerollOne(+swap.getAttribute('data-swap')); return; }
    var info = e.target.closest('[data-info]');
    if (info) { openModal(+info.getAttribute('data-info')); return; }
    var im = e.target.closest('.bw-rc__imgwrap');
    if (im) { var card = im.closest('.bw-rc'); openModal([].indexOf.call(gridEl.children, card)); }
  });


  // ---------- detail modal: swipeable gallery + description, never leaves the roller
  var modal    = document.querySelector('[data-roll-modal]');
  var mTrack   = modal && modal.querySelector('[data-modal-track]');
  var mDots    = modal && modal.querySelector('[data-modal-dots]');
  var mIdx     = 0, mSlide = 0, mShots = [];

  function renderDots() {
    if (!mDots) return;
    mDots.innerHTML = mShots.map(function (_, i) {
      return '<span class="bw-dot' + (i === mSlide ? ' is-on' : '') + '"></span>';
    }).join('');
  }
  /* Nick, 2026-09-05: a wide photo left a wall of dead space — size the viewer to the
     photo that's actually showing instead of to the tallest one in the set. */
  function fitGal() {
    var gal = mTrack && mTrack.parentNode;
    if (!gal) return;
    var img = mTrack.children[mSlide] && mTrack.children[mSlide].querySelector('img');
    if (!img) return;
    var apply = function () {
      var h = img.getBoundingClientRect().height;
      if (h > 20) gal.style.height = Math.round(h) + 'px';
    };
    if (img.complete && img.naturalWidth) apply();
    else img.addEventListener('load', apply, { once: true });
  }
  function goSlide(n) {
    if (!mShots.length) return;
    mSlide = (n + mShots.length) % mShots.length;
    mTrack.style.transform = 'translateX(' + (-mSlide * 100) + '%)';
    renderDots();
    fitGal();
  }
  function openModal(i) {
    if (!modal || !hand[i]) return;
    BWT.views++;
    bwtLog('view', hand[i].item.t);
    mIdx = i;
    var it = hand[i].item;
    mShots = (it.imgs && it.imgs.length) ? it.imgs : (it.img ? [it.img] : []);
    mTrack.innerHTML = mShots.map(function (src) {
      return '<div class="bw-modal__slide"><img src="' + src + '" alt="" loading="lazy"></div>';
    }).join('');
    mSlide = 0; goSlide(0); setTimeout(fitGal, 60);
    modal.querySelector('[data-modal-title]').textContent = it.t;
    modal.querySelector('[data-modal-price]').textContent = money(it.p);
    modal.querySelector('[data-modal-desc]').textContent = it.d || '';
    modal.querySelector('[data-modal-keep]').textContent = hand[i].locked ? '\u2764 Locked in \u2014 tap to release' : '\u2661 Lock this one in';
    modal.hidden = false;
    document.body.classList.add('bw-modal-open');
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('bw-modal-open');
  }
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-modal-close]')) { closeModal(); return; }
      if (e.target.closest('[data-gal-prev]')) { goSlide(mSlide - 1); return; }
      if (e.target.closest('[data-gal-next]')) { goSlide(mSlide + 1); return; }
      if (e.target.closest('[data-modal-keep]')) {
        hand[mIdx].locked = !hand[mIdx].locked;
        if (hand[mIdx].locked) BWT.locks++;
        bwtLog(hand[mIdx].locked ? 'lock' : 'unlock', hand[mIdx].item.t);
        this.querySelector('[data-modal-keep]').textContent = hand[mIdx].locked ? '\u2764 Locked in \u2014 tap to release' : '\u2661 Lock this one in';
        render(); return;
      }
      if (e.target.closest('[data-modal-swap]')) { rerollOne(mIdx); closeModal(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') goSlide(mSlide - 1);
      if (e.key === 'ArrowRight') goSlide(mSlide + 1);
    });
    // touch swipe
    var sx = 0, dx = 0, sy = 0, swiping = false;
    var gal = modal.querySelector('[data-modal-gal]');
    gal.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; swiping = true;
    }, { passive: true });
    gal.addEventListener('touchmove', function (e) {
      if (!swiping) return;
      dx = e.touches[0].clientX - sx;
      if (Math.abs(dx) > Math.abs(e.touches[0].clientY - sy)) {
        mTrack.style.transform = 'translateX(calc(' + (-mSlide * 100) + '% + ' + dx + 'px))';
      }
    }, { passive: true });
    gal.addEventListener('touchend', function () {
      swiping = false;
      if (Math.abs(dx) > 45) goSlide(mSlide + (dx < 0 ? 1 : -1)); else goSlide(mSlide);
    });
  }

  root.querySelector('[data-roll-deal]').addEventListener('click', function () { deal(false); });

  var refineBtn = root.querySelector('[data-roll-refine]');
  var advEl = root.querySelector('[data-roll-adv]');
  if (refineBtn && advEl) {
    refineBtn.addEventListener('click', function () {
      var open = advEl.hidden;
      advEl.hidden = !open;
      refineBtn.setAttribute('aria-expanded', String(open));
      refineBtn.classList.toggle('is-on', open);
    });
  }
  var panelClose = root.querySelector('[data-panel-close]');
  if (panelClose && advEl) {
    panelClose.addEventListener('click', function () {
      advEl.hidden = true;
      if (refineBtn) { refineBtn.setAttribute('aria-expanded', 'false'); refineBtn.classList.remove('is-on'); }
    });
  }
  againEls.forEach(function (b) { b.addEventListener('click', function () { deal(true); }); });

  root.addEventListener('click', function (e) {
    var more = e.target.closest('[data-roll-more]');
    if (more) {
      var chip = root.querySelector('.bw-chip[data-val="' + more.getAttribute('data-next') + '"]');
      if (chip) chip.click(); // reuse the normal chip path so state + is-on stay in sync
      return;
    }
    if (e.target.closest('[data-sub-info]')) {
      var pop = root.querySelector('[data-sub-pop]');
      if (pop) pop.hidden = !pop.hidden;
    }
  });


  function addPack(btn, dest) {
    if (!hand.length) { deal(false); if (!hand.length) return; }
    var btnTxt = btn.textContent; btn.disabled = true; btn.textContent = 'One sec\u2026';
    var kept = hand.map(function (h) { return h.item.t; });
    var kids = {}; hand.forEach(function (h) { kids[h.item.id] = 1; });
    var passed = [];
    BWT.seen.forEach(function (t) { if (kept.indexOf(t) === -1) passed.push(t); });
    var secs = Math.round((Date.now() - BWT.t0) / 1000);
    var lineProps = {
      '_roller': 'homepage',
      '_roller_rolls': String(BWT.rolls),
      '_roller_seconds': String(secs)
    };
    var items = hand.map(function (h) {
      return { id: h.item.id, quantity: 1, properties: lineProps };
    });
    var cSub = curSub();
    if (cSub) items.push({ id: cSub.id, quantity: 1, properties: { '_roller': 'homepage-addon' } });
    bwtLog(dest === 'checkout' ? 'buy-now' : 'add-to-cart');
    var attrs = {
      'Roller': 'homepage',
      'Roller who': bwtWho(),
      'Roller session': BWT.sid,
      'Roller started at': new Date(BWT.t0).toISOString().replace('T', ' ').slice(0, 19) + ' UTC',
      'Roller finished at': bwtNow() + ' UTC',
      'Roller actions': bwtClip(BWT.log, 480),
      'Roller rolls': String(BWT.rolls),
      'Roller swaps': String(BWT.swaps),
      'Roller undos': String(BWT.undos),
      'Roller locked in': String(BWT.locks),
      'Roller details opened': String(BWT.views),
      'Roller filter changes': String(BWT.filters),
      'Roller plants seen': String(BWT.seen.length),
      'Roller seconds': String(secs),
      'Roller pack size': String(hand.length),
      'Roller substrate': cSub ? (state.sub === '2' ? '5 gal' : '1.5 gal') : 'none',
      'Roller filters': bwtFilters(),
      'Roller exit': dest === 'checkout' ? 'Buy now' : 'Add to cart',
      'Roller kept': bwtClip(kept, 480),
      'Roller passed on': bwtClip(passed, 480)
    };
    var rootUrl = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          btn.disabled = false; btn.textContent = btnTxt;
          emptyEl.hidden = false;
          emptyEl.textContent = (res.d && res.d.description) || 'One of those just sold out \u2014 reroll and try again.';
          return;
        }
        /* stamp the session onto the cart, then go. Never block the sale on this. */
        var go = function () { window.location.href = rootUrl + dest; };
        fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).then(go, go);
      })
      .catch(function () { btn.disabled = false; btn.textContent = btnTxt; });
  }
  var buyEl = root.querySelector('[data-roll-buy]');
  if (buyEl) buyEl.addEventListener('click', function () { addPack(this, 'checkout'); });
  root.querySelector('[data-roll-add]').addEventListener('click', function () { addPack(this, 'cart'); });

  deal(false);
  BWT.ready = true;
})();
